/**
 * Quotes Module - Frontend (R28)
 *
 * Exports the frontend components for the Quotes module:
 * - SettingsPage: the module's page (/channels/:id/modules/quotes) - the quote
 *   book's management: search, add, edit, delete, export. Matt (2026-10-29):
 *   management lives on the module's page, not the channel overview.
 *
 * No ChannelPanel and no DashboardWidget. Who may run the commands, and their
 * cooldowns, are the command platform's per-channel overrides (R31 brings
 * that editor onto this same page).
 */

import { Quote } from 'lucide-react'
import type { FrontendModule } from '../types'

import { QuotesPanel } from './QuotesPanel'

/**
 * Quotes module definition. `name` matches the backend's ModuleMeta.name.
 */
export const quotesModule: FrontendModule = {
  name: 'quotes',
  displayName: 'Quotes',
  SettingsPage: QuotesPanel,
  icon: Quote,
}

export { QuotesPanel }

// Picked up by the registry's build-time glob (modules/index.ts, R23).
export default quotesModule
